import { ChatComposerHero } from './ChatComposerHero';

export function WorkspaceHome() {
    return <ChatComposerHero />;
}
